export default class LazyMediaController {
	constructor() {
		this.initialized = false;
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.lazyLoadImages();
		this.lazyLoadIframes();
	}

	lazyLoadImages() {
		const images = document.querySelectorAll('.lazy-load-image-n');
		if (!images.length) {
			return;
		}

		if (!('IntersectionObserver' in window)) {
			images.forEach((image) => this.loadImage(image));
			return;
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				this.loadImage(entry.target);
				observer.unobserve(entry.target);
			});
		});

		images.forEach((image) => observer.observe(image));
	}

	lazyLoadIframes() {
		const iframes = document.querySelectorAll('.lazy-iframes');
		if (!iframes.length) {
			return;
		}

		if (!('IntersectionObserver' in window)) {
			iframes.forEach((iframe) => this.loadIframe(iframe));
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						return;
					}

					this.loadIframe(entry.target);
					observer.unobserve(entry.target);
				});
			},
			{
				threshold: 0.5,
				rootMargin: '0px 0px 100px 0px',
			}
		);

		iframes.forEach((iframe) => observer.observe(iframe));
	}

	loadImage(image) {
		if (!image.dataset.src) {
			return;
		}

		image.src = image.dataset.src;
		image.addEventListener(
			'load',
			() => {
				image.classList.remove('lazy-load-image-n');
			},
			{ once: true }
		);
	}

	loadIframe(iframe) {
		const src = iframe.getAttribute('data-src');
		if (src) {
			iframe.src = src;
		}
	}
}
